import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-rollback-opera',
  templateUrl: './modal-rollback-opera.component.html'
})
export class ModalRollbackOperaComponent {
  @Input() entries: { data?: string; utente?: string; motivazione?: string, ente?: string }[] = [];
  @Input() title: string = 'Cronologia modifiche';

  constructor(public activeModal: NgbActiveModal) {}
}